module.exports = __webpack_public_path__ + "img/logo-eveno.83269a03.svg";